<template>
  <b-modal size="xl" button-size="sm" v-model="showModal" :title="title" hide-footer @hidden="cancelar">
    <div class="modal-header justify-content-center" style="padding: 0px">
      <h5 class="text-center" style="padding: 0px">{{ empresaNome }}</h5>
    </div>

    <div class="modal-body">
      <b-card bg-variant="light">
        <b-form @submit.prevent="handleSubmit">
          <b-row class="mb-3">
            <b-col>
              <lg-form-const-select @change="load()" v-model="selectedStatusDocumento" id="selectedStatusDocumento"
                :options="documentoOptions" />
            </b-col>
            <b-col>
              <lg-form-const-select @change="load()" v-model="situacao" id="situacao" :options="optionsFilterSituacao"
                placeholder="Selecione..." />
            </b-col>
            <b-col>
              <lg-form-input id="searchText" v-model="searchText" />
            </b-col>
            <b-col>
              <b-form-group class="b-form-group-styled d-flex align-items-center">
                <b-button id="localizarDocumento" @click="load" size="sm" class="ml-2" style="height: 30px" pill
                  variant="primary">
                  <div class="btn-size-alinhamento">
                    <b-icon icon="search" />
                  </div>
                </b-button>
                <b-tooltip target="localizarDocumento" title="Clique para localizar documentos"
                  triggers="hover"></b-tooltip>

                <b-button id="limparDocumento" class="ml-2" style="height: 30px" size="sm" pill variant="primary"
                  @click="limpar">
                  <div class="btn-size-alinhamento">
                    <b-icon icon="eraser" />
                  </div>
                </b-button>
                <b-tooltip target="limparDocumento" title="Clique para limpar os filtros" triggers="hover"></b-tooltip>

                <b-button v-if="temPrivilegioCadastro()" class="ml-2" pill id="addDocument" variant="primary" style="height: 30px" size="sm"
                  @click="addDocument">
                  <div class="btn-size-alinhamento">
                    <b-icon scale="1.5" icon="plus" />
                  </div>
                </b-button>
                <b-tooltip target="addDocument" title="Clique para adicionar um documento" triggers="hover"></b-tooltip>

                <b-button v-if="temPrivilegioCadastro()" class="ml-2" pill id="addMultipleDocuments" variant="primary" style="height: 30px" size="sm"
                  @click="addMultipleDocuments">
                  <div class="btn-size-alinhamento">
                    <b-icon scale="1.5" icon="folder-plus" />
                  </div>
                </b-button>
                <b-tooltip target="addMultipleDocuments" title="Clique para adicionar múltiplos documentos"
                  triggers="hover"></b-tooltip>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
        <b-table :items="this.records" :fields="fields" responsive="sm" striped :hover="true" show-empty
          :busy="this.busy">
          <template #empty>
            <p>Nenhum registro encontrado</p>
          </template>

          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
          <template #cell(nome)="data">
            <div class="link-container">
              <a class="custom-link" @click.prevent="downloadArquivo(data)">{{
                data.item.arquivo.nome
              }}</a>
            </div>
          </template>
          <template #cell(editar)="{ item }">
            <b-button :disabled="!temPrivilegioEdicao()" id="editar" class="my-2" size="sm" pill variant="primary" @click="ModalEditar(item)">
              <b-icon icon="pencil-square" />
              <b-tooltip target="editar" title="Editar..." triggers="hover"></b-tooltip>
            </b-button>
          </template>
          <template v-slot:cell(situacao)="{ item }">
            <b-form-checkbox :disabled="!temPrivilegioEdicao()" v-model="item.situacao" @change="alteraSituacao(item)" id="situacaoDocumentos"
              name="check-button" switch size="lg" :value="1" :unchecked-value="0" />
            <b-tooltip target="situacaoDocumentos" title="Alterar situação" triggers="hover"
              class="text-right"></b-tooltip>
          </template>
        </b-table>

        <b-row style="margin-top: 12px" v-if="records && records.length > 0">
          <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
            Página {{ page }} de {{ totalPage }} - {{ total }} registros
          </b-col>
          <b-col cols="6">
            <div class="d-flex justify-content-end align-items-end">
              <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                :total-rows="total"></b-pagination>
            </div>
          </b-col>
        </b-row>
        <ModalDocumentosAdicionar v-if="showModalAdicionar" :codEmpresa="codEmpresa" :prefix="updatedPrefix"
          @fechar="fechar" :id="idEdit" />
        <ModalDocumentosAdicionarVarios v-if="showModalAdicionarMultiplos" :codEmpresa="codEmpresa" @fechar="fechar"
          :prefix="updatedPrefix" />
      </b-card>
    </div>
  </b-modal>
</template>

<script>
import { downloadArquivo } from "@/components/generators/downloads"
import ResourceService from "@/core/api/ResourceService"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import ConfirmMixin from "@/core/mixins/confirm"
import { ListResourceMixin } from "@/core/mixins/resource"
import ModalDocumentosAdicionar from "./ModalDocumentosAdicionar.vue"
import ModalDocumentosAdicionarVarios from "./ModalDocumentosAdicionarVarios.vue"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"


export default {
  components: {
    LgFormInput,
    LgFormConstSelect,
    ModalDocumentosAdicionar,
    ModalDocumentosAdicionarVarios,
  },
  data() {
    return {
      idEdit: null,
      showModal: true,
      showModalAdicionar: false,
      showModalAdicionarMultiplos: false,
      busy: false,
      selectedStatusDocumento: null,
      searchText: "",
      situacao: 1,
      documentoOptions: [
        { value: null, text: "Selecione..." },
        { value: 125, text: "Atualizado" },
        { value: 124, text: "Vencido" },
        { value: 68, text: "Vigente" },
      ],
      optionsFilterSituacao: [
        { key: "filterSituacao", text: "Todos", value: undefined },
        { key: "filterSituacao", text: "Ativo", value: "1" },
        { key: "filterSituacao", text: "Inativo", value: "0" },
      ],
      fields: [
        { key: "nome", label: "Arquivo do Documento", tdClass: "px-3" },
        {
          key: "tipoDocumentoDescricao",
          label: "Tipo do Documento",
          tdClass: "px-2",
        },
        { key: "status", label: "Status", tdClass: "px-2" },
        {
          key: "localizacaoFisica",
          label: "Localização Física",
          tdClass: "px-2",
        },
        { key: "numero", label: "N°", tdClass: "px-2" },
        { key: "editar", label: "" },
        { key: "situacao", label: "" },
      ],
    };
  },
  mixins: [ListResourceMixin, ConfirmMixin],
  beforeMount() {
    this.$service = new ResourceService(`/api/documentos-empresa`);
  },
  mounted() {
    this.load();
  },
  props: {
    prefix: Array,
    empresaNome: String,
    codEmpresa: Number,
  },
  computed: {
    updatedPrefix() {
      return [...this.prefix, "Documento de Empresa"];
    },
    title() {
      return this.updatedPrefix.join(" > ");
    },
  },
  watch: {
    page() {
      this.load()
    },
  },

  methods: {
    temPrivilegioCadastro() {
      return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_INCLUIR);

    },
    temPrivilegioEdicao() {
      return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_EDITAR);

    },

    async alteraSituacao(item) {
      let response;

      if (item.situacao == 1) {
        response = await this.$confirm(`Deseja ativar o registro?`);
      }
      if (item.situacao == 0) {
        response = await this.$confirm(`Deseja desativar o registro?`);
      }

      if (response === true) {
        this.confirmarAlteracaoSituacao(item);
      } else {
        item.situacao = item.situacao == 1 ? 0 : 1;
      }
    },

    async confirmarAlteracaoSituacao(item) {
      const { status } = await this.$service.alteraSituacao(item);

      if (status == 200) {
        this.$notify({
          type: "success",
          message: `Registro ${item.situacao ? "Ativado" : "Desativado"
            } com sucesso!`,
        });
      } else {
        this.$notify({
          type: "danger",
          message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
            } o registro!`,
        });
      }
    },
    ModalEditar(item) {
      this.idEdit = item.id;
      this.showModalAdicionar = true;
    },
    handleSubmit(event) {
      event.preventDefault();
      this.load();
    },
    downloadArquivo(result) {
      let item = {
        arquivo: result.item.arquivo.arquivo,
        nomeDocumento: result.item.arquivo.nome,
      };
      downloadArquivo(item);
    },
    closeModal() {
      this.showModal = false;
    },
    async load() {
      this.busy = true;
      var filtro = {};
      if (this.codEmpresa) {
        filtro.codEmpresa = this.codEmpresa;
      }
      if (this.searchText) {
        filtro.pesquisaEmpresa = this.searchText;
      }
      if (this.situacao != undefined) {
        filtro.situacao = this.situacao;
      }
      if (this.selectedStatusDocumento) {
        filtro.statusDocumento = this.selectedStatusDocumento;
      }

      await this.$loadResource({
        limit: this.perPage,
        page: this.page,
        params: filtro,
      });
      this.busy = false;
    },
    addDocument() {
      this.showModalAdicionar = true;
    },
    addMultipleDocuments() {
      this.showModalAdicionarMultiplos = true;
    },
    limpar() {
      this.selectedStatusDocumento = null;
      this.situacao = 1;
      this.searchText = "";
      this.load();
    },
    cancelar() {
      this.$emit("close");
    },
    fechar() {
      this.showModalAdicionar = false;
      this.showModalAdicionarMultiplos = false;
      this.idEdit = null;
      this.load();
    },
  },
};
</script>

<style scoped>
.custom-link {
  color: blue;
  text-decoration: underline;
  text-align: center;
  cursor: pointer;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-body {
  padding-top: 1rem;
}

.table-header {
  margin-bottom: 1rem;
}

.b-table td,
.b-table th {
  vertical-align: middle;
}
</style>
